"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var App_vue_1 = __importDefault(require("./App.vue"));
exports.default = {
    initComponent: function (element, elementSelector, options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        vue_1.default.config.productionTip = options.vueProductionTip;
        var layout = (_a = element.dataset.layout) !== null && _a !== void 0 ? _a : undefined;
        var jobName = (_b = element.dataset.jobName) !== null && _b !== void 0 ? _b : '';
        var specializationName = (_c = element.dataset.specializationName) !== null && _c !== void 0 ? _c : '';
        var inputJob = {
            id: (_d = element.dataset.inputJobId) !== null && _d !== void 0 ? _d : '',
            name: (_e = element.dataset.inputJobName) !== null && _e !== void 0 ? _e : '',
            label: (_f = element.dataset.inputJobLabel) !== null && _f !== void 0 ? _f : '',
            placeholder: (_g = element.dataset.inputJobPlaceholder) !== null && _g !== void 0 ? _g : '',
        };
        var inputSpecialization = {
            id: (_h = element.dataset.inputSpecializationId) !== null && _h !== void 0 ? _h : '',
            name: (_j = element.dataset.inputSpecializationName) !== null && _j !== void 0 ? _j : '',
            label: (_k = element.dataset.inputSpecializationLabel) !== null && _k !== void 0 ? _k : '',
            placeholder: (_l = element.dataset.inputSpecializationPlaceholder) !== null && _l !== void 0 ? _l : '',
        };
        var vm = new App_vue_1.default({
            propsData: {
                layout: layout,
                jobName: jobName,
                specializationName: specializationName,
                inputJob: inputJob,
                inputSpecialization: inputSpecialization
            },
        });
        vm.$mount(elementSelector);
    }
};
